export const agreementWithdrawalFields = {
  TYPE: 'type',
  PETITIONER: 'petitioner',
  REASON: 'reason',
  CREATED_AT: 'createdAt',
  CONFIRMED_AT: 'confirmedAt',
  EFFECTIVE_AT: 'effectiveAt',
};
